import { defineComponent as o, createBlock as r, openBlock as n, mergeProps as m, unref as s, withCtx as a, renderSlot as f } from "vue";
import { useBindCx as i } from "@scalar/components";
import c from "./DataTableCell.vue.js";
const x = /* @__PURE__ */ o({
  __name: "DataTableHeader",
  setup(p) {
    const { cx: e } = i();
    return (t, u) => (n(), r(c, m({ is: "th" }, s(e)("items-center font-medium px-2 min-w-0 -outline-offset-1")), {
      default: a(() => [
        f(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  x as default
};
